<button
  type="button"
  class="block size-full overflow-hidden p-0 border-0 bg-[#1A433A]"
  [class.rounded-full]="!square"
  [class.rounded-sm]="square"
  [class.ring-2]="clickable"
  [class.ring-accent]="clickable"
  [class.ring-offset-1]="clickable"
  [class.cursor-pointer]="clickable"
  [class.cursor-default]="!clickable"
  [disabled]="!clickable"
  [attr.aria-label]="clickable ? 'View public profile' : null"
  [attr.tabindex]="tabbable ? null : -1"
  (click)="onClick()"
>
  <img
    *ngIf="photoUrl; else initialsFallback"
    [src]="photoUrl"
    alt="Profile picture"
    class="size-full object-cover"
  />
  <ng-template #initialsFallback>
    <span class="size-full flex items-center justify-center text-accent font-semibold select-none">
      {{ entity | initials }}
    </span>
  </ng-template>
</button>
